import React, {useState} from 'react';
import b_ from 'b_';

import I18N from 'assets/i18n/brandlift-project';

import {UserInfo} from 'client/common/types';
import InfoBlock from 'client/common/components/info-block';
import {sessionStorageClient} from 'client/common/utils/storage';
import {getCreativeCurrency} from 'client/common/utils/price';
import {CreativesBoxType} from 'client/creatives/types';

import './creative-list.css';

const i18n = I18N.creatives.creativeList;
const b = b_.with('creative-list');

interface CreativeInfoProps {
    boxType: CreativesBoxType;
    userInfo?: UserInfo;
}

export function CreativeInfo(props: CreativeInfoProps) {
    const {boxType, userInfo} = props;

    const infoKey = `${boxType}_info_closed`;
    const [infoClosed, setInfoClosed] = useState<boolean>(
        sessionStorageClient.getDataFromStorage(infoKey)
    );
    const onInfoContainerClose = () => {
        sessionStorageClient.saveDataToStorage(infoKey, true);
        setInfoClosed(true);
    };

    if (infoClosed) {
        return null;
    }

    const currency = getCreativeCurrency(userInfo);

    return (
        <InfoBlock className={b('info-container')} closable onClose={onInfoContainerClose}>
            <div>
                <strong>{i18n.info.creatives.boldTitle}</strong>: {i18n.info.creatives.title}
            </div>
            <div>{i18n.info.creatives.row1}</div>
            <div>{i18n.info.creatives.row2}</div>
            <div>{i18n.info.creatives.cost[currency]}</div>
        </InfoBlock>
    );
}
